module.exports = __webpack_public_path__ + "img/专利总数.8827e816.png";